// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type MinusIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from minus.svg
 */
export default function MinusIcon(props: MinusIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="MinusIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M14 8a1 1 0 0 0-1-1H3l-.117.007A1 1 0 0 0 3 9h10l.117-.007A1 1 0 0 0 14 8"
        />
      </g>
    </svg>
  );
}
